import {sendSentryError} from './sentry';

const SW_URL = `/site_media/static/${BUNDLES_PATH}service-worker.js`;

export const setupServiceWorker = (): Promise<ServiceWorkerRegistration> =>
  new Promise((resolve, reject) => {
    if (window.navigator.serviceWorker == undefined) {
      reject(new Error('Service worker not supported'));
    }

    window.navigator.serviceWorker
      .register(SW_URL, {
        scope: '/',
      })
      .then(resolve, (err) => {
        sendSentryError(err);
        throw err;
      });
  });
